import React from 'react';
import './clientes.css';
import Metro from './imagenes/metro.png';
import Pemex from './imagenes/pemex.png';
import Satelite from './imagenes/plaza-satelite.png';
import Artz from './imagenes/artz.png';
import Indra from './imagenes/indra.png';
import Teltronic from './imagenes/Teltronic.png';
type ClientLogo = {
  name: string;
  src: string;
};

const clientLogos: ClientLogo[] = [
  { name: 'Metro', src: Metro },
  { name: 'PEMEX', src: Pemex },
  { name: 'Plaza Satelite', src: Satelite },
  { name: 'Plaza Artz', src: Artz},
  { name: 'INDRA', src: Indra },
  { name: 'Teltronic', src: Teltronic},
  // agrega o ajusta según tus marcas reales
];

const ClientsCarousel: React.FC = () => {
  return (
    <section
      className="brands2026"
      aria-label="Clientes y marcas con las que hemos trabajado"
    >
      <div className="brands-inner">
        <header className="brands-header">
          <p className="brands-eyebrow">Confían en ARYSOLTEC</p>
          <h2 className="brands-title">Marcas y aliados</h2>
          <p className="brands-subtitle">
            Empresas de distintos sectores que respaldan nuestra calidad
            en soluciones tecnológicas, integración y acompañamiento continuo.
          </p>
        </header>

        <div className="brands-carousel">
          <div className="brands-track-mask">
            <div className="brands-track">
              {clientLogos.map((logo) => (
                <div className="brand-item" key={logo.name}>
                  <div className="brand-logo-card">
                    <img src={logo.src} alt={logo.name} />
                  </div>
                </div>
              ))}
              {/* Duplicado para efecto infinito */}
              {clientLogos.map((logo) => (
                <div className="brand-item" key={`${logo.name}-dup`}>
                  <div className="brand-logo-card">
                    <img src={logo.src} alt={logo.name} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Segunda fila opcional (puedes eliminarla si quieres sólo una) */}
          <div className="brands-track-mask brands-track-mask--reverse">
            <div className="brands-track brands-track--reverse">
              {clientLogos.map((logo) => (
                <div className="brand-item" key={`${logo.name}-row2`}>
                  <div className="brand-logo-card brand-logo-card--soft">
                    <img src={logo.src} alt={logo.name} />
                  </div>
                </div>
              ))}
              {clientLogos.map((logo) => (
                <div className="brand-item" key={`${logo.name}-row2-dup`}>
                  <div className="brand-logo-card brand-logo-card--soft">
                    <img src={logo.src} alt={logo.name} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ClientsCarousel;
